import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isFileInviteePanelOpenSelector,
  isUploadingFileInviteesSelector,
  setIsFileInviteePanelOpen,
  uploadFileInvitees,
} from '../../../../../../../features/pageFeatures/createHearingPageSlice';
import { getFileExtensionFromFileName } from '../../../../../../../utilities/files';

export const useUploadInviteeFile = (
  hearingId,
  invitationSource,
  fileExtension,
  maxFileSizeInBytes,
) => {
  const dispatch = useDispatch();

  const [hasError, setHasError] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);

  const isPanelOpen = useSelector(isFileInviteePanelOpenSelector);
  const isUploadingFile = useSelector(isUploadingFileInviteesSelector);

  useEffect(() => {
    setHasError(false);
    setFileToUpload(null);
    setFileUrl(null);
  }, [isPanelOpen]);

  useEffect(() => {
    if (!isPanelOpen && fileUrl) {
      URL.revokeObjectURL(fileUrl);
    }
  }, [isPanelOpen, fileUrl]);

  const fileName = fileToUpload && fileToUpload.name;

  function onChangeFile(event) {
    URL.revokeObjectURL(fileUrl);

    const [file] = event.target.files;
    if (
      file.size === 0 ||
      file.size > maxFileSizeInBytes ||
      !file ||
      (file && getFileExtensionFromFileName(file.name) !== fileExtension)
    ) {
      setHasError(true);
      setFileToUpload(null);
      setFileUrl(null);
    } else {
      setHasError(false);
      setFileToUpload(file);
      const newFileUrl = URL.createObjectURL(file);
      setFileUrl(newFileUrl);
    }
  }

  function onPanelClose() {
    dispatch(setIsFileInviteePanelOpen(false));
    setHasError(false);
    setFileToUpload(null);
    setFileUrl(null);
  }

  function onConfirm() {
    dispatch(
      uploadFileInvitees({ file: fileToUpload, hearingId, invitationSource }),
    );
    setHasError(false);
    setFileToUpload(null);
    setFileUrl(null);
  }

  return {
    fileName,
    fileToUpload,
    fileUrl,
    hasError,
    isPanelOpen,
    isUploadingFile,
    onChangeFile,
    onPanelClose,
    onConfirm,
  };
};
